import type { InsightsData } from "@/services/insightsApi";

export function shouldShowVotingNotEnabled(errorStatus: number | null, insights: InsightsData | null): boolean {
  return errorStatus === 404 || (insights !== null && insights.target_type !== "subtheme");
}
